import React from 'react';
import { Container, Card } from 'react-bootstrap';

function LifeGoals() {
  return (
    <Container className="py-4">
      <h1 className="mb-4">Life Goals Financial Planner</h1>
      <Card className="shadow-sm">
        <Card.Body>
          <Card.Title>Align Your Business with Your Life</Card.Title>
          <Card.Text className="text-muted">
            Connect your business goals to your personal financial targets.
            See how your business decisions impact your life outcomes.
          </Card.Text>
          <hr />
          <p className="text-muted mb-0">
            <em>Coming soon: Life goal setting, financial projections, and business-life alignment tools.</em>
          </p>
        </Card.Body>
      </Card>
    </Container>
  );
}

export default LifeGoals;
